import { render } from "./CxStatsPanel.vue?vue&type=template&id=69801bf6"
import script from "./CxStatsPanel.vue?vue&type=script&lang=js"
export * from "./CxStatsPanel.vue?vue&type=script&lang=js"

import "./CxStatsPanel.vue?vue&type=style&index=0&id=69801bf6&lang=less"

import exportComponent from "/home/ec2-user/workspace/_ui2_staging_ui2-staging-0.124.0/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__